/* src/app/shared/components/non-employee/non-employee.component.scss */
p {
  padding: 2rem;
}
/*# sourceMappingURL=non-employee.component.css.map */
